import { makeActionCreator } from '../../configs/store/utils'

export const CLOSE_UNIQUE_PASS_DIALOG = 'CLOSE_UNIQUE_PASS_DIALOG'
export const onCloseUniquePassDialog = makeActionCreator(CLOSE_UNIQUE_PASS_DIALOG)

export const SHOW_UNIQUE_PASS_DIALOG = 'SHOW_UNIQUE_PASS_DIALOG'
export const onShowUniquePassDialog = makeActionCreator(SHOW_UNIQUE_PASS_DIALOG)
